import script from "./CatalogueList.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogueList.vue?vue&type=script&setup=true&lang=js"

import "./CatalogueList.vue?vue&type=style&index=0&id=d26647b2&lang=scss"

export default script